
import {throwError as observableThrowError, forkJoin} from 'rxjs';
import {map, catchError, first} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {RequestService} from '../request/request.service';

@Injectable()
export class FileService {
  apiUrl = environment.apiRoot;
  fileUrl = environment.fileServiceRoot;

  constructor(private reqService: RequestService) {
  }

  upload(file) {
    file.append('public', 1);
    file.append('client', 'lina');
    file.append('protected', 0);

    const req = {
      url: this.fileUrl + 'upload',
      data: file,
      config: {
        successToast: false,
        waitForCompletion: false
      }
    };

    return this.reqService.postRequest(req).pipe(
      map((result: any) => {
        return result;
      }),
      catchError(error => observableThrowError(error)));
  }

  multipleUpload(files) {
    const requests = [];
    files.map((file: any) => {
      requests.push(this.upload(file));
    });

    return forkJoin(requests);
  }

}
